import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['sdk', 'mobile']

  connect () {
    if (typeof FloTelematics !== 'undefined') {
      this.sdkTarget.innerHTML = I18n.t('more.about.show.headers.sdk_about_html', {
        version: FloTelematics.getVersion()
      })
      this.mobileTarget.innerHTML = I18n.t('more.about.show.headers.mobile_about_html', {
        version: FloTelematics.getAAAMobileVersion()
      })
    }
  }
}
